import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { StringInput } from '../../../shared/field-inputs';

interface StringFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function StringFieldRenderer({ fieldKey, field, form, label, disabled = false }: StringFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'string') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <StringInput
            value={formField.value}
            onChange={formField.onChange}
            label={label}
            placeholder={`Enter ${fieldKey}...`}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
